import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['spinner', 'link'];
  static values = {
    sessionId: String,
    challengeUrl: String
  };

  onAppLinkClick(event) {
    this.linkTarget.classList.add('hidden');
    this.spinnerTarget.classList.remove('hidden');
  }

  onUniversalLinkClick(event) {
    event.preventDefault()
    this.linkTarget.classList.add('hidden');
    this.spinnerTarget.classList.remove('hidden');

    fetch(this.challengeUrlValue, {
      method: 'POST',
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
      },
    })
      .then(response => response.json())
      .then(json => {
        window.location.replace(json["verification_url"])
      })
  }
}
